import Axios from 'axios'

import { SERVER_BASE_URL } from '../baseUrl'

export const createAvis = async (token: string, avisData: object) => {
  try {
    const response = await Axios.post(`${SERVER_BASE_URL}api/avis`, avisData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}
